<template>
  <div>
    <div class="News-box box-class">
      <div class="News-title">新闻咨讯</div>
      <div class="News-title-tips">Press Releases</div>
      <!-- <div class="News-service">技术支持/人才服务/保障服务/其他服务</div>
        <div class="News-picture">
          <img src="@/assets/img/banner_01.png" alt="" v-for="i in 4" />
        </div> -->
      <div class="News-method">
        <div class="News-method-left">
          <img src="@/assets/img/banner_01.png" alt="" />
          <div class="img-cover"></div>
          <div class="img-content">123</div>
        </div>
        <div class="News-method-right">
          <div class="box-content" v-for="(item, i) in newsInfo" :key="i">
            <div class="title">
              <div class="t1">{{ item[0] }}</div>
              <div class="t2">{{ item[1] }}</div>
            </div>
            <div class="content">
              <div class="t1">{{ item[2] }}</div>
              <div class="t2">{{ item[3] }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "News",
  data() {
    return {
      name: "新闻",
      newsInfo: [
        { 0: "2023", 1: "10.10", 2: "新闻标题", 3: "内容" },
        { 0: "2023", 1: "10.10", 2: "新闻标题", 3: "内容" },
        { 0: "2023", 1: "10.10", 2: "新闻标题", 3: "内容" },
        { 0: "2023", 1: "10.10", 2: "新闻标题", 3: "内容" },
        { 0: "2023", 1: "10.10", 2: "新闻标题", 3: "内容" },
      ],
    };
  },
  mounted() {
    console.log("MyComponent mounted"); // 输出：MyComponent mounted
  },
};
</script>

<style lang="less" scoped>
.News-box {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 35px 0;

  .News-title {
    font-size: 0.4743rem;
    font-weight: bold;
    color: #333;
    padding: 5.0031px 6.0024px;
    border-bottom: 1px solid rgba(26, 158, 101, 0.4);
  }

  .News-title-tips {
    font-size: 0.1897rem;
    color: rgba(26, 158, 101, 0.8);
    margin-top: 0.0791rem;
  }

  .News-service {
    font-size: 0.253rem;
    font-weight: 500;
    margin-top: 20px;
  }

  .News-picture {
    width: 8.6957rem;
    height: 4.7431rem;
    min-width: 275px;
    min-height: 190px;
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: center;

    img {
      width: 35%;
      min-width: 100px;
      height: 40%;
      min-height: 80px;
      margin: 0.1581rem 0.3162rem;
      border-radius: 10px;
    }
  }
}

.box-class {
  background-color: #ffffff;
}

.box-class2 {
  background-color: #ffffff;
  padding-bottom: 0px;
}

.News-method {
  // width: 14.2292rem;
  height: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 0.3162rem;

  .News-method-left {
    width: 6.6403rem;
    min-width: 260px;
    height: 4.7431rem;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    margin-top: 30px;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
    }

    .img-cover {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;
      background-color: rgba(77, 77, 77, 0.5);
    }

    .img-content {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      color: #ffffff;
    }
  }

  .News-method-right {
    width: 6.6403rem;
    min-width: 260px;
    height: 4.7431rem;
    min-height: 300px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    margin-top: 30px;

    .box-content {
      width: 100%;
      height: 60px;
      line-height: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 15px;
      border-bottom: 1px solid #e5e5e5;

      .title {
        width: 100px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        letter-spacing: 1px;
        font-weight: 500;

        .t1 {
          font-size: 26px;
        }

        .t2 {
          font-size: 16px;
          margin-top: 6px;
        }
      }

      .content {
        width: 70%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        font-size: 18px;

        .t1 {
          font-weight: bold;
        }

        .t2 {
          font-size: 12px;
          color: #5f5f5f;
          margin-top: 3px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/News.vue